module.exports = __webpack_public_path__ + "img/isChuli.3b5d9fc6.svg";